<script lang="ts">
  import Button from '$lib/components/Button.svelte';
  import type { UserLessonStore } from 'shared/src/user/userLessons/user.lesson.store';
  import { createEventDispatcher } from 'svelte';

  export let lessonPage: UserLessonStore['pages'][number];

  interface $$Events {
    contentEnded: CustomEvent<null>;
  }

  const dispatch = createEventDispatcher<$$Events>();
</script>

<div class="unreset px-4 pb-4">
  {@html lessonPage.content}
  <div class="text-center">
    <Button on:click={() => dispatch('contentEnded')}>Next</Button>
  </div>
</div>

<style lang="postcss">
  :global(h1),
  :global(h2),
  :global(h3),
  :global(h4),
  :global(h5),
  :global(h6) {
    @apply text-slate-600;
  }
</style>
